module.exports = __webpack_public_path__ + "assets/img/study_2.62822c85.png";